export const theme = {
  brown1: '#3F3E3C',
  brown2: '#7A6C5D',
  brown3: '#9E9489',
  brown4: '#E6E4E1',
  white: '#FFFFFF',
  fontThin: 100,
  fontLight: 300,
  fontBold: 700,
  green: '#69BF53',
  red: '#FF2E2E',
  lightGreen: '#E4FCDE',
  fontSize: {
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.6rem',
    m: '2.1rem',
    l: '2.4rem',
    xl: '4rem',
  },
};
